<template>
  <tr>
    <td>
      <div class="d-flex align-center">
        <v-avatar
          size="32"
          class="mr-2 white--text"
          :color="'#' + Math.floor(Math.random()*16777215).toString(16)"
        >
          {{ team.shortName }}
        </v-avatar>
        {{ team.name }}
      </div>
    </td>
    <td>
      <v-chip
        v-for="coach in team.coaches"
        :key="'coach'+coach.id"
        small
        outlined
        class="mr-1"
      >
        {{ coach.first_name }} {{ coach.last_name }}
      </v-chip>
    </td>
    <td>{{ team.players_count }}</td>
    <td v-if="hasMultipleSports">
      {{ $t(`sport.${toCamelCase(team.sport.name)}`) }}
    </td>
    <td>
      <div class="d-flex">
        <v-btn
          icon
          class="mr-2"
          @click="$emit('edit', team)"
        >
          <v-icon small>
            fal fa-edit
          </v-icon>
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>

import { toCamelCase } from '@/utils/helpers'

export default {
  name: 'TeamsListTableRow',
  props: {
    team: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    hasMultipleSports() {
      return this.user.organisation_settings.has_multiple_sports
    }
  },
  methods: { toCamelCase }
}
</script>
